import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import * as paramActions from '../../../components/paramHistory/store/actions';
import { Icon, TextField, Button, IconButton } from '@material-ui/core';
import DraggableModule from './DraggableModule';
import DraggableOrphanLesson from './DraggableOrphanLesson';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../store/actions';

class AddItems extends Component {

    state = { value: 'one' }

    handleTabChange = (event, value) => {
        this.setState({ value });
    }

    handleLessonSearchChange = (e) => {
        this.setState({ lessonSearch: e.target.value });
    }

    handleModuleSearchChange = (e) => {
        this.setState({ moduleSearch: e.target.value });
    }

    handleLessonAdd = () => {
        this.props.addLessonParamUpdate({active: true, course_id: this.props.course_id, startingPoint: 'course', CourseName: this.props.course.CourseName})
        this.props.history.push('/lesson/create')
    }

    render() {
        const { value, lessonSearch, moduleSearch } = this.state
        const { mappedLessons, allLessons, alreadySelectedModules, allModules, course_id, modulePreviewData } = this.props

        let relatedLessonIDs = mappedLessons.map(lesson => {
            return lesson.lesson_id
        })

        let draggableLessonItems = allLessons
            .filter(lesson => lesson.Unscheduled === 0)
            .filter(lesson => !lessonSearch || lesson.LessonName.toLowerCase().includes(lessonSearch.toLowerCase()))
            .map(lesson => {
                if (relatedLessonIDs.includes(lesson.lesson_id)) {
                    return (
                        <DraggableOrphanLesson
                            alreadySelected={true}
                            item={lesson}
                            key={lesson.lesson_id}
                            course_id={course_id}
                            onDrop={this.props.dropOrphanLesson}
                        />
                    )
                }
                return (
                    <DraggableOrphanLesson
                        alreadySelected={false}
                        item={lesson}
                        key={lesson.lesson_id}
                        course_id={course_id}
                        onDrop={this.props.dropOrphanLesson}
                    />
                )
            })

        let relatedModuleIDs = alreadySelectedModules.map(module => {
            return module.module_id
        })

        let draggableModuleItems = allModules
            .filter(module => !moduleSearch || module.ModuleName.toLowerCase().includes(moduleSearch.toLowerCase()))
            .map((module) => {
                if (relatedModuleIDs.includes(module.module_id)) {
                    return (
                        <DraggableModule
                            alreadySelected={true}
                            item={module}
                            key={module.module_id}
                            course_id={course_id}
                            onDrop={this.props.dropModuleToDay}
                            onExpand={this.props.modulePreview}
                            modulePreviewData={modulePreviewData.filter(m => m.module_id === module.module_id)}
                        />
                    )
                }
                return (
                    <DraggableModule
                        alreadySelected={false}
                        item={module}
                        key={module.module_id}
                        course_id={course_id}
                        onDrop={this.props.dropModuleToDay}
                        checkDuplicates={this.props.checkDuplicateLessonConflict}
                        checkOverwrite={this.props.checkDayLessonConflict}
                        onExpand={this.props.modulePreview}
                        modulePreviewData={modulePreviewData.filter(m => m.module_id === module.module_id)}
                    />
                )
            })

        const addLesson =
            <IconButton
                onClick={() => this.handleLessonAdd()}
            >
                <Icon style={{ fontSize: '24px', color: 'white', marginBottom: '3px' }} >add</Icon>
            </IconButton>

        return (

            <div>
                <div>
                    <AppBar position="static">
                        <Tabs value={value} onChange={this.handleTabChange}>
                            <Tab style={{ minWidth: '50%' }} value="one" label="Module" />
                            <Tab style={{ minWidth: '50%' }} value="two" label={<div>Lesson {addLesson} </div>} />
                        </Tabs>
                    </AppBar>
                    {value === 'one' &&
                        <div style={{ height: '400px', overflowY: 'scroll' }} >
                            <TextField
                                id="search"
                                label={<Icon>search</Icon>}
                                value={this.state.moduleSearch}
                                onChange={(e) => this.handleModuleSearchChange(e)}
                                margin="normal"
                                disabled={this.props.view_type === 'detail'}
                                style={{ width: '90%', marginLeft: '5%' }}
                            />
                            {draggableModuleItems}
                        </div>
                    }
                    {value === 'two' &&
                        <div style={{ height: '400px', overflowY: 'scroll' }} >
                            {/* <Button
                                variant="contained"
                                // className={classes.button}
                                onClick={() => this.handleLessonAdd()}
                            >
                                Add Lesson
                            </Button>
                            <br></br> */}
                            <TextField
                                id="search"
                                label={<Icon>search</Icon>}
                                // className={this.props.classes.textFieldSearch}
                                value={this.state.lessonSearch}
                                onChange={(e) => this.handleLessonSearchChange(e)}
                                margin="normal"
                                disabled={this.props.view_type === 'detail'}
                                style={{ width: '90%', marginLeft: '5%' }}
                            />
                            {draggableLessonItems}
                        </div>
                    }
                </div>

            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        dropOrphanLesson: Actions.dropOrphanLesson,
        dropModuleToDay: Actions.dropModuleToDay,
        handleOverwriteCheckChange: Actions.handleOverwriteCheckChange,
        handleDuplicateSubmit: Actions.handleDuplicateSubmit,
        handleOverwriteSubmit: Actions.handleOverwriteSubmit,
        checkDuplicateLessonConflict: Actions.checkDuplicateLessonConflict,
        checkDayLessonConflict: Actions.checkDayLessonConflict,
        modulePreview: Actions.modulePreview,
        addLessonParamUpdate: paramActions.updateCourseBuilderParams
    }, dispatch);
}

function mapStateToProps({ courseApp }) {
    return {

    }

}

export default (withRouter(connect(mapStateToProps, mapDispatchToProps)(AddItems)));


// WEBPACK FOOTER //
// src/main/content/course/scheduleComponents/AddItems.js